<template>
    <div>
        <Rate v-if="showRating" />
        <div v-if="!showRating" class="d-flex mb-2" style="align-content: space-between; justify-content: space-evenly">
            <a-button icon="interaction" size="large" style="border-radius: 20px" type="primary" @click="reconnect">
                {{ $t("message.reConnect") }}
            </a-button>
            <a-button icon="star" size="large" style="border-radius: 20px" type="primary" @click="toggleRating(true)">
                {{ $t("message.evaluate") }}
            </a-button>
        </div>
    </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Rate from "./Rate";
import { getPersistenceData } from "../../utils/persistenceStorage";
import { log2 } from "../../utils/log2";
import version from "../../utils/version";
import { sendSocketMessage } from "../../utils/socketStream";
import { getVisitorToken, VISITOR_TOKEN_SUPPORTED } from "../../utils/visitorToken";

const log = log2("AfterActions");
export default {
    name: "AfterActions",
    components: { Rate },
    computed: {
        ...mapState({
            visitorId: (state) => state.chat.visitorId,
            conversationId: (state) => state.chat.conversationId,
            showRating: (state) => state.app.showRating,
            site: (state) => state.site.site,
        }),
    },
    methods: {
        ...mapActions({
            toggleCloseChatConfirmation: "app/toggleCloseChatConfirmation",
            toggleAfterActions: "app/toggleAfterActions",
            toggleRating: "app/toggleRating",
            resetConversation: "chat/resetConversation",
        }),
        connect() {
            sendSocketMessage("visitor connect", {
                visitorId: getPersistenceData("visitorId", null),
                visitorToken: getVisitorToken(),
                tokenSupported: VISITOR_TOKEN_SUPPORTED,
                conversationId: this.conversationId,
                siteId: this.site._id,
                version,
            });
        },
        reconnect() {
            this.toggleAfterActions(false);
            this.resetConversation();

            this.connect();
        },
    },
};
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/components/V2/AfterActions.vue